import React, { useCallback } from 'react';

import { Button } from "@material-ui/core";
import { createStyles, makeStyles, withStyles, WithStyles } from '@material-ui/core/styles';

import { AlmeMarkdownResponseNext } from "../../AlmeResponse/AlmeResponse";
import { ResponseAction } from "@alme/types/response/ResponseAction";

import ctaButtonStyles from './AlmeCtaButton.styles';
import { AlmeApiUtils } from '../../../api/AlmeApiUtils';
import { FocusComponentProps } from '../../../models/ComponentProps';
import { DisplayLinkTargetTypes } from '@alme/types/response/DisplayLinkTargetTypes';
import { UnitDisplayLink } from '@alme/types/response/UnitDisplayLink';
import { EntryExtensionData } from '@alme/types/response/EntryExtensionData';
import { AlmeCtaButtonConfig } from './AlmeCtaButtonConfig';

export interface CtaResponseAction extends ResponseAction {
    ButtonDisplayText: string;
    ButtonTarget: string;
    ButtonType: DisplayLinkTargetTypes;
    parameters: {
        UnitLabel: string;
        Type: string;
    };
    Name: "CallToActionButton";
}

const useStyles = makeStyles(() =>
    createStyles({
        root: {
        },
    }),
);

interface AlmeCtaButtonProps extends WithStyles<typeof ctaButtonStyles> {
    response: AlmeMarkdownResponseNext;
    onCtaClick: (action: CtaResponseAction, entryId: string) => Promise<void>;
    focusProps?: FocusComponentProps;
    responseId: string;
    almeConfig: AlmeCtaButtonConfig;
}

const AlmeCtaButton: React.FC<AlmeCtaButtonProps> = (props: AlmeCtaButtonProps) => {
    const classes = useStyles();

    const responseRevision = (props.responseId || props.response.responseRevision).toString();

    // ? TODO: can you have multiple call to action buttons?
    const getCtaResponseAction = (): CtaResponseAction | null => {
        if (!props.response.responseActions)
            return null;
        else {
            for (const action of props.response.responseActions) {
                if (action.Name === "CallToActionButton") {
                    return action as CtaResponseAction;
                }
            }
            return null;
        }
    };

    const entryId = (props.response.extensionData && (props.response.extensionData as EntryExtensionData).entryId) || props.response.responseRevision.toString();

    const inlineAction = getCtaResponseAction();
    if (!inlineAction) {
        return null;
    } else {
        return (
            <Button
                id={`alme-iva-card-${responseRevision}-cta`}
                color={props.almeConfig.ctaButton.styles.button.color}
                variant={props.almeConfig.ctaButton.styles.button.variant}
                className={`${props.classes.ctaButton} ${classes.root}`}
                onClick={() => { void props.onCtaClick(inlineAction, entryId); }}
                fullWidth
                {...props.focusProps}
            >{inlineAction.ButtonDisplayText}</Button>
        );
    }
};

export default withStyles(ctaButtonStyles)(AlmeCtaButton);

export function OnCtaClickCallback(apiUtils: React.MutableRefObject<AlmeApiUtils>): (action: CtaResponseAction, entryId: string) => Promise<void> {
    return useCallback(async (action: CtaResponseAction, entryId: string): Promise<void> => {
        const unitLink = {
            Metadata: {
                UnitUID: action.ButtonTarget,
            },
            DisplayText: action.ButtonDisplayText,
        } as UnitDisplayLink;
        await apiUtils.current.submitUnitRequest(unitLink, {
            ...action.parameters,
            entryId,
        });
    }, [apiUtils]);
}